import { el, setAttr } from 'redom';

import serverInterface from 'server-interface';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import ElementPlacer from 'lib/element-placer';

import {
  findByPropertyValue
} from 'utilities/collection';

import SingleValueSelector from '../single-value-selector';

import {
  convertColumnsToFields
} from './utilities';

class FieldSelector {

  constructor(options) {

    this.elementPlacer = null;
    this.visible = false;
    this.fieldsLoaded = false;
    this.collectionId = options.collectionId;
    this.fields = convertColumnsToFields(options.columns);
    this.scrollAnchorElement = null;
    this.scrollableParentId = null;

    this.onSelect = null;
    this.onClose = null;

    this.input = null;

    this.initializeInput();

    this.el = el('#field-selector-main', [this.input]);

  }

  onmount() {

    this.registerOutsideEventHandler();

  }

  onunmount() {

    this.unregisterOutsideEventHandler();

  }

  initializeInput() {

    const options = {
      value: { label: '' },
      options: this.fields,
      onSelect: this.handleFieldSelect.bind(this),
      onClose: this.handleInputClose.bind(this),
      skipPositioning: true,
      optionsLoader: this.loadOptions.bind(this)
    };

    this.input = new SingleValueSelector(options);

  }

  loadOptions(searchTerm) {

    return this.fields.filter(function checker(field) {
      return field.label.toLowerCase().includes(searchTerm.toLowerCase());
    }).sort(function sorter(a, b) {
      return a.label.localeCompare(searchTerm) < b.label.localeCompare(searchTerm);
    });

  }

  async initialize() {}

  setScrollableParentId(scrollableParentId) {

    this.scrollableParentId = scrollableParentId;

  }

  reconfigure(options) {

    this.scrollAnchorElement = options.scrollAnchorElement;
    this.onSelect = options.onSelect;
    this.onClose = options.onClose;
    this.input.setPlaceholder(options.placeholder);
    this.setField(options.field);

    setAttr(this.el, {
      style: {
        width: this.scrollAnchorElement.offsetWidth + 'px'
      }
    });

    this.initializePlacer();

  }

  updatePosition() {
    setTimeout(() => this.popper.update(), 1);
  }

  initializePlacer() {

    // If I forget to call cancel...
    if (this.elementPlacer !== null) {
      this.elementPlacer.cancel();
    }

    const configuration = {
      element: this.el,
      anchor: this.scrollAnchorElement,
      container: 'viewport',
      scrollableParent: document.getElementById(this.scrollableParentId),
      spacing: {
        top: 5
      }
    };
    this.elementPlacer = new ElementPlacer(configuration);

  }

  show() {

    this.visible = true;
    setAttr(this.el, { style: { display: 'block' } });
    this.el.classList.add('active');
    this.elementPlacer.placeVertically();
    this.input.focus();
    this.input.clear();

  }

  hide() {

    this.visible = false;
    setAttr(this.el, { style: { display: 'none' } });
    this.el.classList.remove('active');

    if (this.elementPlacer !== null) {
      this.elementPlacer.cancel();
    }

  }

  getFields() {

    return this.fields;

  }

  handleFieldSelect(field) {

    this.onSelect(field);

  }

  handleInputClose() {

    // this.onClose();

  }

  outsideClickHandler(clickTargetElement) {

    if (this.visible === false) {
      return;
    }

    if (this.scrollAnchorElement === clickTargetElement || this.scrollAnchorElement.contains(clickTargetElement) === true) {
      return;
    }

    this.onClose();

  }

  registerOutsideEventHandler() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.outsideClickHandler.bind(this));

  }

  unregisterOutsideEventHandler() {

    this.outsideEventRegistration.cancel();

  }

  setField(field) {

    if (field === null) {
      return;
    }

    this.input.setValue(field);

  }

  async customValuesLoader(field, searchTerm) {

    const key = field.key;
    const filterOptions = {};
    const trimmed = searchTerm.trim();

    if (trimmed !== '') {
      filterOptions.searchTerm = trimmed;
    }

    const results = await serverInterface.startup.dataCollections.getColumnValuesByQueryOptions(this.collectionId, key, {
      filterOptions,
      paginationOptions: {
        skip: 0,
        limit: 5
      }
    });

    if (results.length === 0) {
      return [];
    }

    return results[0].values;

  }

  getFieldByKey(key) {

    return findByPropertyValue(this.fields, 'key', key);

  }

}

export default FieldSelector;